import captainAppVersions from "./captainAppVersions.component";
import captainAppVersionsUrls from "./captainAppVersions.urls";
import CaptainAppVersionsTransforms from "./captainAppVersions.transforms";

const captainAppVersionsModule = angular
  .module("app.components.captainAppVersions", [])
  .component("captainAppVersionsPage", captainAppVersions)
  .service("CaptainAppVersionsTransforms", CaptainAppVersionsTransforms)
  .config(captainAppVersionsUrls);

export default captainAppVersionsModule;



// WEBPACK FOOTER //
// ./src/pages/captainAppVersions/captainAppVersions.module.js